<script>
  import { CloseCircle } from '@/icons'
  import activityCenterMixin from '../mixins/activityCenterMixin'
  import AppliedFilters from '@/views/payouts/components/AppliedFilters.vue'
  import EmptyIssues from '../EmptyIssues.vue'
  import Filters from './Filters.vue'
  import OrderIssue from './OrderIssue.vue'
  import Pagination from '@/components/UI/Pagination.vue'

  export default {
    name: 'OrderIssuesTable',

    mixins: [activityCenterMixin],

    components: {
      AppliedFilters,
      CloseCircle,
      EmptyIssues,
      Filters,
      OrderIssue,
      Pagination
    },

    methods: {
      clearFiltersHandler() {
        this.orderIssuesFilters = { store_domain: 'all stores', event: 'all_events' }
        this.orderIssuesPartnerStore = null
        this.orderIssuesSearchStr = ''
        this.fetchActivitiesHandler()
      },

      updateCurrentPageHandler(page) {
        this.orderIssuesCurrentPage = page
        this.fetchActivitiesHandler(this.orderIssuesCurrentPage)
      }
    }
  }
</script>

<template>
  <article>
    <Filters />

    <!-- Applied Filters -->
    <section class="applied-filters-row d-flex align-center">
      <aside class="d-flex align-center left-action">
        <div class="applied-filters-listing d-flex align-center">
          <strong>Filters:</strong>
          <AppliedFilters :appliedFilters="orderIssuesFilters" />
        </div>
      </aside>
      <div class="right-action-container">
        <button class="btn-icon d-flex align-center clear-filters-btn" @click="clearFiltersHandler">
          <CloseCircle /> <span class="btn-icon--text">Clear Filters</span>
        </button>
      </div>
    </section>

    <section class="table">
      <v-simple-table>
        <template>
          <thead>
            <tr>
              <th style="width: 10%;">Date (AEST)</th>
              <th style="width: 25%;">Issue and suggested action</th>
              <th style="width: 20%;">Order</th>
              <th style="width: 20%;">Detail</th>
              <th style="width: 15%;"></th>
              <th style="width: 10%;" class="text-right">Actions</th>
            </tr>
          </thead>
          <EmptyIssues v-if="orderIssues && orderIssues.length === 0" :colspan="'6'" />
          <tbody>
            <OrderIssue v-for="issue in orderIssues" :key="issue.id" :issue="issue" />
          </tbody>
        </template>
      </v-simple-table>

      <!-- Pagination -->
      <Pagination :pagination="orderIssuesPagination" @updateCurrentPage="updateCurrentPageHandler" />
    </section>
  </article>
</template>
